const black = require('./font-type/ToyotaType-Black.otf');
const bold = require('./font-type/ToyotaType-Bold.otf');
const book = require('./font-type/ToyotaType-Book.otf');
const light = require('./font-type/ToyotaType-Light.otf');
const regular = require('./font-type/ToyotaType-Regular.otf');
const semibold = require('./font-type/ToyotaType-Semibold.otf');

const fonts = {
  black,
  bold,
  book,
  light,
  regular,
  semibold,
};

export default fonts;
